import { render } from "./StylePicker.vue?vue&type=template&id=47088c9d&scoped=true"
import script from "./StylePicker.vue?vue&type=script&lang=js"
export * from "./StylePicker.vue?vue&type=script&lang=js"

import "./StylePicker.vue?vue&type=style&index=0&id=47088c9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47088c9d"]])

export default __exports__